import { motion } from "framer-motion";
import { MessageCircle, Images } from "lucide-react";
import { api, fileUrl, inr, waLink, orderMessage } from "@/lib/api";

export function ProductCard({ product, index, whatsappNumber, onOpen }) {
  const onOrder = () => {
    api.post(`/products/${product.id}/tap`).catch(() => {});
    window.open(waLink(whatsappNumber, orderMessage(product)), "_blank");
  };
  const onSale = product.mrp && Number(product.mrp) > Number(product.price);
  const photoCount = product.images && product.images.length ? product.images.length : product.image_url ? 1 : 0;
  return (
    <motion.article
      data-testid={`product-card-${product.id}`}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.06 }}
      className="card-gold group flex flex-col overflow-hidden rounded-2xl bg-white shadow-[0_4px_20px_-4px_rgba(122,28,40,0.08)]"
    >
      <button data-testid={`product-quick-view-${product.id}`} onClick={onOpen} className="relative block w-full overflow-hidden" aria-label={`View ${product.name}`}>
        <img
          data-testid={`product-image-${product.id}`}
          src={fileUrl(product.image_url)}
          alt={product.name}
          loading="lazy"
          className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {onSale ? (
          <span data-testid={`sale-badge-${product.id}`} className="absolute top-3 right-3 rounded-full bg-maroon border border-gold px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-soft">
            Festive Sale
          </span>
        ) : null}
        {product.tag && !onSale ? (
          <span data-testid={`product-tag-${product.id}`} className="absolute top-3 left-3 rounded-full bg-ivory/95 border border-gold-line px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-maroon">
            {product.tag}
          </span>
        ) : null}
        {photoCount > 1 ? (
          <span data-testid={`photo-count-${product.id}`} className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-ink/50 px-2.5 py-1 text-[10px] font-semibold text-white backdrop-blur-sm">
            <Images className="w-3.5 h-3.5" />
            {photoCount}
          </span>
        ) : null}
        {!product.in_stock ? (
          <span className="absolute inset-0 flex items-center justify-center bg-ink/40 text-white text-sm font-semibold">Out of Stock</span>
        ) : null}
      </button>
      <div className="flex flex-1 flex-col gap-2 p-3 sm:p-4">
        <div className="flex items-start justify-between gap-2">
          <h3 data-testid={`product-name-${product.id}`} className="font-display text-base sm:text-lg font-semibold leading-snug text-ink">
            {product.name}
          </h3>
          <div className="shrink-0 text-right">
            <p data-testid={`product-price-${product.id}`} className="text-base sm:text-lg font-bold text-maroon">
              {inr(product.price)}
            </p>
            {onSale ? (
              <p data-testid={`product-mrp-${product.id}`} className="text-xs text-ink-muted line-through">
                {inr(product.mrp)}
              </p>
            ) : null}
          </div>
        </div>
        <p className="text-[11px] uppercase tracking-wider text-gold-text font-semibold">{product.category}</p>
        <button
          data-testid={`whatsapp-order-btn-${product.id}`}
          onClick={onOrder}
          disabled={!product.in_stock}
          className="mt-auto inline-flex w-full items-center justify-center gap-2 rounded-full bg-whats px-4 py-2.5 text-sm font-semibold text-white hover:bg-whats-dark transition-colors duration-200 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <MessageCircle className="w-4 h-4" />
          Order on WhatsApp
        </button>
      </div>
    </motion.article>
  );
}
